import React from 'react'
import GroutProductList from './GroutProductList'
import AppNavigation from '../../AppNavigation'

export default function GroutQuoteCreated() {
   return (
      <React.Fragment>
         <div className="col-xs-12 col-md-9 col-md-push-3">
               <GroutProductList />
         </div>
         <AppNavigation />
      </React.Fragment>
   )
}


// WEBPACK FOOTER //
// ./src/components/productTypes/grout/GroutProductSelection.js